// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"2a82513640065271d398","655":"ba3056949564bd8ca26c"}[chunkId] + ".js";
};